const options = [
    { id: 'nfc', name: 'nfc' },
    { id: 'ble', name: 'ble' },
];
export default options;
